<template>
	<b-card>
		<div slot="header">
			<span @click="changeVisible" style="font-size: 15px; font-weight: bold">Преобразовать товары</span>
			<div class="card-header-actions" style="display: flex; align-items: center">
				<!-- <b-button-group class="mr-3" size="sm">
					<b-button @click="changeTab('out')" :variant="activeTab === 'out' ? 'primary' : 'outline-primary'" style="font-weight: bold">Out</b-button>
					<b-button @click="changeTab('in')" :variant="activeTab === 'in' ? 'primary' : 'outline-primary'" style="font-weight: bold">In</b-button>
				</b-button-group> -->
				<b-badge @click="$router.push('/warehouse-management/item-convert-create')"
					style="font-size: 15px; cursor: pointer" class="mr-2" variant="primary"><i
						class="fa fa-plus" /></b-badge>
			</div>
		</div>
		<b-row class="mt-3">
			<b-col>
				<table ref="table" class="table-striped table-bordered table-hover" style="width: 100%">
					<thead>
						<tr>
							<th class="text-center">{{ '№' }}</th>
							<th v-if="visibleChanges" class="text-center">{{ $t('Обнoвлён') }}</th>
							<th v-if="visibleChanges" class="text-center">{{ $t('Дата обновления') }}</th>
							<th class="text-center">{{ $t('incomes.create.reg-number') }}</th>
							<th class="text-center">{{ $t('incomes.create.reg-date') }}</th>
							<th class="text-center">{{ $t('inventory.department') }}</th>
							<th class="text-center">{{ $t('client.create.category') }}</th>
							<th class="text-center">{{ '#' }}</th>
						</tr>
					</thead>
					<tbody v-for="(item, index) in items" :key="`table-${index}`">
						<tr>
							<td class="text-center">{{ index + 1 }}</td>
							<td v-if="visibleChanges" class="text-center">{{ item.docLastModifiedBy }}</td>
							<td v-if="visibleChanges" class="text-center">{{ item.docChangedDate }}</td>
							<td class="text-center">{{ item.regNumber }}</td>
							<td class="text-center">{{ item.regDate }}</td>
							<td class="text-center">{{ item.fromDepartmentName?item.fromDepartmentName:item.toDepartmentName }}</td>
							<td class="text-center">{{ item.documentStatus }}</td>
							<td class="text-center">
								<span class="fa fa-eye text-dark mr-2" style="cursor: pointer; font-size: 15px"
									@click="viewItem(item, index)" />
								<span class="fa fa-file-text-o text-primary" style="cursor: pointer; font-size: 15px"
									@click="viewItemDetails(item, index)" />
							</td>
						</tr>
					</tbody>
					<tbody v-if="items.length === 0">
						<tr>
							<td colspan="9" class="text-center">
								<h4>{{ $t('empty') }}</h4>
							</td>
						</tr>
					</tbody>
				</table>
				<nav class="mt-2" v-if="total > 0">
					<b-pagination :total-rows="total" :per-page="payload.limit" v-model="payload.page"
						aria-controls="table" />
				</nav>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect"
import UsersService from "../../../services/users.sevice";
import WhDocument from "../../../services/wh-document.service";
import { computed } from "vue";

export default {
	name: "index",
	components: { Multiselect },
	data() {
		return {
			items: [],
			total: 0,
			departments: [],
			dep: null,
			name: '',
			loading: false,
			depDisable: false,
			activeTab: 'out',
			payload: {
				page: 1,
				limit: 20
			}
		}
	},
	computed:{
		visibleChanges() {
			let can = false
			localStorage.getItem('canViewChange')==='true' ? can = true : can = false
			return can
		}
	},
	watch: {
		'payload.page': {
			handler(p) {
				if (String(this.$route.query.page) !== String(p)) {
					this.$router.replace({ query: { ...this.$route.query, page: p } })
				}
				this.getItems();
			}
		}
	},
	methods: {
		changeVisible() {
			if(localStorage.getItem('canViewChange')==='true') {
				localStorage.setItem('canViewChange', 'false')
			}else {
				localStorage.setItem('canViewChange', 'true')
			}
		},
		getItems() {
			this.loading = true
			let data = {
				page: this.payload.page,
				limit: this.payload.limit
			}
			const docType = this.activeTab === 'in' ? 'conversion-in' : 'conversion-out';
			WhDocument.getDocList(data, docType).then(res => {
				if (res) {
					this.items = res.data.items
					this.total = res.data.total
				}
				this.loading = false
			})
		},
		changeTab(tab) {
			if (this.activeTab !== tab) {
				this.activeTab = tab;
				this.payload.page = 1;
				this.getItems();
			}
		},
		viewItem(item, index) {
			this.$router.push(`/warehouse-management/item-convert-view/${item.id}`)
		},
		viewItemDetails(item, index) {
			this.$router.push(`/warehouse-management/item-convert-view2/${item.id}`)
		}
	},
	created() {
		if (this.$route.query.page && this.payload.page !== Number(this.$route.query.page)) {
			this.payload.page = Number(this.$route.query.page);
		} else {
			this.getItems();
		}
	}
}
</script>

<style scoped></style>
